import { render } from "./AddQcmByAi.vue?vue&type=template&id=404d72e1"
import script from "./AddQcmByAi.vue?vue&type=script&lang=js"
export * from "./AddQcmByAi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__